import { resolvePlaybookType } from 'utils/playbooks'
import { createReducer } from 'utils/redux'

export const BOT_FLOW_MODES = {
  BUILD: 'BUILD',
  CONTENT_VIEW: 'CONTENT_VIEW',
}

const defaultState = {
  connectedCalendarIds: null,
  type: null,
  isPreviewState: false,
  geoTargetingDismissed: [],
  botFlowMode: BOT_FLOW_MODES.BUILD,
}

const setPlaybookType = ({ draft, action }) => {
  draft.type = resolvePlaybookType(action.reportType)
}

const setPreviewState = ({ draft, action }) => {
  draft.isPreviewState = action.isPreview
}

const setConnectedCalendars = ({ draft, action }) => {
  draft.connectedCalendarIds = action.ids
}

const setGeoTargetingDismissed = ({ draft, action }) => {
  const playbookIds = [...draft.geoTargetingDismissed]
  playbookIds.push(action.playbookId)
  draft.geoTargetingDismissed = playbookIds
}

const setBotFlowMode = ({ draft, action }) => {
  draft.botFlowMode = action.botFlowMode
}

const actions = {
  SET_PLAYBOOK_TYPE: setPlaybookType,
  SET_PREVIEW_STATE: setPreviewState,
  SET_CONNECTED_CALENDARS: setConnectedCalendars,
  SET_GEO_TARGETING_DISMISSED: setGeoTargetingDismissed,
  SET_BOT_FLOW_MODE: setBotFlowMode,
}

const editorReducer = createReducer(defaultState, actions)

export default editorReducer
